import { httpClient } from "../http/httpClient";
import { SupportRequestAttachment } from "@/app/entities/SupportRequest";

export interface PublicSupportUser {
  name?: string;
  cpf?: string;
}

export interface UploadSupportAttachmentsParams {
  id: string;
  files: File[];
  user?: PublicSupportUser;
}

export async function uploadSupportAttachments({
  id,
  files,
  user,
}: UploadSupportAttachmentsParams) {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("files", file);
  });

  if (user) {
    if (user.name) formData.append("name", user.name);
    if (user.cpf) formData.append("cpf", user.cpf);
  }

  const { data } = await httpClient.post<SupportRequestAttachment[]>(
    `/support-requests/${id}/attachments${user ? "/public" : ""}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );

  return data;
}
